module.exports = __webpack_public_path__ + "media/images/front/pc/error/img_404-f56786d335fda740c3ef8004a25382d7.png";